import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalBodyDirective } from './modal-body.directive';
import { ModalFooterDirective } from './modal-footer.directive';
import { ModalTitleDirective } from './modal-title.directive';
import { ModalComponent } from './modal.component';

export * from './modal.component';
export * from './modal-body.directive';
export * from './modal-title.directive';
export * from './modal-footer.directive';
export * from './modal.service';
export * from './modal-ref';
export * from './modal.config';
@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [
    ModalComponent,
    ModalBodyDirective,
    ModalTitleDirective,
    ModalFooterDirective,
  ],
  exports: [
    ModalComponent,
    ModalBodyDirective,
    ModalTitleDirective,
    ModalFooterDirective,
  ],
})
export class ModalModule {}
